angular.module('7Shop.Core').constant('LocalData', {});
